module.exports = __webpack_public_path__ + "static/media/pierre.8c5ae433.png";